import React from "react";
import { ReactSVG } from "react-svg";
import { SidebarIconProps } from "../types/SidebarIconProps";

export const SidebarIcon = (props: SidebarIconProps) => {
    return (
        <ReactSVG
            src={`${props.src}`}
            // eslint-disable-next-line
            beforeInjection={(svg: any) => {
                if (props.style) {
                    svg.setAttribute("style", `${props.style}`);
                } else {
                    svg.setAttribute("style", "width: 32px; height: 32px;");
                }
                svg.setAttribute("fill", props.fill);
            }}
            className="sidebar-icon"
        ></ReactSVG>
    );
};
